<div class="translation-key-toggle" cdkDrag>
  Show translation keys
  <mat-checkbox [ngModel]="status" (change)="toggelShowTranslationKeys()">
  </mat-checkbox>
</div>